import { FULL_ACCESS_ACTION_NAMES } from 'widget/ui-selectors/video-access';

import { DEFAULT_TRANSLATIONS as PURCHASE_TRANSLATIONS } from 'widget/components/overlay-texts/purchase-button-text';

import * as dealInfoHelpers from 'shared/utils/deal-info-helpers';

import commonTranslations from 'shared/translations/overlay-common-translations';


export default function getTranslationData(fullAccessAction, channel, video) {
  switch (fullAccessAction) {
    case FULL_ACCESS_ACTION_NAMES.BUY:
      return {
        props: PURCHASE_TRANSLATIONS[fullAccessAction],
        priceModel: dealInfoHelpers.getSalePriceInfo(video.dealInfo),
      };
    case FULL_ACCESS_ACTION_NAMES.RENT:
      return {
        props: PURCHASE_TRANSLATIONS[fullAccessAction],
        priceModel: dealInfoHelpers.getRentPriceInfo(video.dealInfo),
      };
    case FULL_ACCESS_ACTION_NAMES.BUY_OR_RENT:
      return {
        props: PURCHASE_TRANSLATIONS[fullAccessAction],
        priceModel: dealInfoHelpers.getMinPriceInfo(video.dealInfo),
      };
    case FULL_ACCESS_ACTION_NAMES.SUBSCRIBE:
      return {
        props: commonTranslations.getSubscription,
        priceModel: dealInfoHelpers.getSubscriptionPriceInfo(channel.dealInfo),
      };
    default:
      return null;
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/player-overlay/ui-selectors/video-overlay/paid-access/translation-data.js